export const LOCALE = 'ja_JP'
export const DEFAULT_LANGUAGE = 'ja'
